import { Box, Grid, Skeleton, Typography } from "@mui/material";
import Link from "next/link";
import Image from "next/image";
import ReactHtmlParser from 'react-html-parser';
import he from "he";
import { IHelpCategoryData } from "@/interfaces/help";
import router from "next/router";

interface CategoryListProps {
    categories: IHelpCategoryData[];
    loading: Boolean;
    linkMain: string;
}

const CategoryList: React.FC<CategoryListProps> = ({ categories, loading, linkMain }) => {
   
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography
                    variant="h6"
                    gutterBottom
                    sx={{ mt: 4, fontFamily: "NotoSansThai-SemiBold", fontSize: "24px" }}
                >
                    หมวดหมู่
                </Typography>
            </Grid>
            {loading ? (
                <>
                    {Array.from({ length: 6 }).map((_, index) => (
                        <Grid item xs={12} sm={6} md={2} key={index}>
                            <Skeleton variant="rectangular" width="100%" height={150} />
                        </Grid>
                    ))}
                </>
            ) : (
                <>
                    {categories.map((data: IHelpCategoryData) => (
                        <Grid xs={6} md={2} sm={3} key={data.category_slug}>
                            <Link
                                href={`${linkMain}${data.category_slug}`}
                                style={{ textDecoration: 'none' }}
                                onMouseOver={(e) => { e.currentTarget.style.color = '#DB5A00'; }}
                                onMouseOut={(e) => { e.currentTarget.style.color = '#292929'; }}
                            >
                                <Box
                                    sx={{
                                        border: "1px solid #000000",
                                        borderColor: "#DEE2E6",
                                        minHeight: "140px",
                                        maxHeight: "150px",
                                        textAlign: "center",
                                        padding: "1rem",
                                        margin: "1rem 0.5rem 0",
                                        width: "75%",
                                        borderRadius: "8px",
                                        alignItems: "center",
                                    }}
                                >
                                    <Box sx={{ width: "100%", display: "block", mt: 1 }}>
                                        <Image
                                            src={data.category_icon_image}
                                            alt={data.category_title}
                                            width={60}
                                            height={60}
                                        />
                                    </Box>
                                    <Typography sx={{ width: "100%", textAlign: "center" }}>
                                        {ReactHtmlParser(he.decode(data.category_title).replace(/<\/?p>/g, ''))}
                                    </Typography>
                                </Box>
                            </Link>
                        </Grid>
                    ))}
                </>
            )}
        </Grid>
    );
};

export default CategoryList;
